<template>
  <div class="ml-5 mr-5 pb-5">
    <div>
      <NotificationMessage v-if="showNotification" :message="notificationMessage" :type="notificationType" :duration="5000"/>
    </div>
    <h4 class="titre1 mb-5 mt-4">RAPPORTS</h4>
    <div class ="container">
    <b-row>
      <b-col md="2">
        <b-button id="soumettre" class="excell" @click.prevent="showModalSoumettre = !showModalSoumettre"><i class="fas fa-file-excel"></i></b-button>
      </b-col>

      <b-col md="4">
        <p class ="textExcell"><b-link @click.prevent="showModalSoumettre = !showModalSoumettre" style="text-decoration: underline">Soumettre un fichier au format Csv </b-link>afin de justifier une ou plusieurs anomalies </p>
      </b-col>
      <b-col md="6">
        <div class = "rapports">
          <p> {{rows}} rapport(s)</p>
        </div>
        <div class="pagination mt-3">
          <b-pagination class="customPagination"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              prev-text="précédent"
              next-text="suivant"
              aria-controls="my-card"
              size="sm"
              align="right">
          </b-pagination>
        </div>
        <div>
          <b-tabs
              active-nav-item-class="font-weight-bold text-black"
              content-class="mt-3"
          >
            <b-tab id="numero" title="N° rapport" active>
              <div class="search">
                <form class="form-inline" >
                  <b-form-input
                      v-on:keyup.enter="searchRapports"
                      placeholder="Numéro"
                      v-model="filter"
                      debounce="200"
                      class="search"
                      type="text">
                  </b-form-input>
                  <b-button style=" border-color:grey" variant="light" @click.prevent="resetFilter">
                    <i class="fas fa-times"></i>
                  </b-button>
                  <button class="btn btn-info" @click.prevent="searchRapports" title="Rechercher">
                    <i class="fas fa-search"></i>
                  </button>
                </form>
              </div>
            </b-tab>
            <b-tab id="nom" title="Nom du jeu">
              <div class="search">
                <form class="form-inline" >
                  <b-form-input
                      v-on:keyup.enter="searchRapportsByJeu"
                      placeholder="Nom du jeu"
                      v-model="filter"
                      debounce="200"
                      class="search"
                      type="text">
                  </b-form-input>
                  <b-button style=" border-color:grey" variant="light" @click.prevent="resetFilter">
                    <i class="fas fa-times"></i>
                  </b-button>
                  <button class="btn btn-info" @click.prevent="searchRapportsByJeu" title="Rechercher">
                    <i class="fas fa-search"></i>
                  </button>
                </form>
              </div>
            </b-tab>
            <b-tab title="Auteur">
                <div class="search">
                <form class="form-inline" >
                  <b-form-input
                      v-on:keyup.enter="searchRapportsByAuteur"
                      placeholder="Nom Auteur"
                      v-model="filter"
                      debounce="200"
                      class="search"
                      type="text">
                  </b-form-input>
                  <b-button style=" border-color:grey" variant="light" @click.prevent="resetFilter">
                    <i class="fas fa-times"></i>
                  </b-button>
                  <button class="btn btn-info" @click.prevent="searchRapportsByAuteur" title="Rechercher">
                    <i class="fas fa-search"></i>
                  </button>
                </form>
              </div>
            </b-tab>
            <b-tab title="Afficher tout" @click="resetFilter"></b-tab>
          </b-tabs>
        </div>
      </b-col>
    </b-row>

      <ModalSoumettreFichier v-if="showModalSoumettre" @close="showModalSoumettre = false" @notification="handleNotification" class="mb-5 mt-5"></ModalSoumettreFichier>

        <b-card id="my-card" bg-variant="secondary"
    v-bind:key ="execution.idExecution" 
    v-for="execution in find" class="mb-3 mt-3">
      <ItemAccordionRapports
      :executionData="execution"
      :idExecution="executionData.idExecution">
      </ItemAccordionRapports>
    </b-card>

      <div class="pagination mt-3">
        <b-pagination class="customPagination"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      prev-text="précédent"
                      next-text="suivant"
                      aria-controls="my-card"
                      size="sm"
                      align="right">
        </b-pagination>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import http from '@/http.js'
import ItemAccordionRapports from "@/components/Rapports/itemAccordionRapports.vue"
import ModalSoumettreFichier from "@/components/Rapports/ModalSoumettreFichier.vue"
import NotificationMessage from "@/components/Notification.vue";

export default {
    name: "RapportList",

    components:{
      NotificationMessage,
        ModalSoumettreFichier,
        ItemAccordionRapports,
    },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup() {
    const filter = ref("");
    const executions = ref([]);
    const executionData = ref({});
    const showModalSoumettre = ref(false);
    const perPage = ref(20);
    const currentPage = ref(1);

    const showNotification = ref(false);
    const notificationMessage = ref("");
    const notificationType = ref("info");

    const handleNotification = ({ toastMessage, toastType }) => {
      notificationMessage.value = toastMessage;
      notificationType.value = toastType;
      showNotification.value = true;
      setTimeout(() => {
        showNotification.value = false;
      }, 5000);
    };

    const find = computed(() => {
      const page = currentPage.value > 1 ? (currentPage.value - 1) * perPage.value : 0;
      return executions.value.slice(page, page + perPage.value);
    });

    const rows = computed(() => executions.value.length);

    const resetFilter = () => {
      filter.value = "";
      getExecutions();
    };

    const getExecutions = async () => {
      const data = await http.getExecutions();
      executions.value = data;
    };

    const searchRapports = async () => {
      const data = await http.searchRapports(filter.value);
      executions.value = data;
    };

    const searchRapportsByJeu = async () => {
      const data = await http.searchRapportsByJeu(filter.value);
      executions.value = data;
    };

    const searchRapportsByAuteur = async () => {
      const data = await http.searchRapportsByAuteur(filter.value);
      executions.value = data;
    };

    onMounted(() => {
      getExecutions();
    });

    return {
      filter,
      executions,
      executionData,
      showModalSoumettre,
      perPage,
      currentPage,
      find,
      rows,
      resetFilter,
      searchRapports,
      searchRapportsByAuteur,
      searchRapportsByJeu,
      showNotification,
      notificationMessage,
      notificationType,
      handleNotification
    };

  }

}
</script>

<style>

.card-body{
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.titres{
  font-size: 20px;
}

.searchBar{
  font-size: 10px !important;
}
.titre1{
  text-align:left !important; 
}
.nav-link{
  font-size: 15px;
}

.nav-tabs {
  border-bottom: none;
  justify-content: center;
}

.nav-link1{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #00a3a6;
}
.nav-link1:hover{
  color: black !important;
}

.nav-link2{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #ed6e6c;
}
.nav-link2:hover{
  color: black !important;
}
.nav-link3{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #9dc544;
}
.nav-link3:hover{
  color: black !important;
}
.nav-link4{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #275662;
}
.nav-link4:hover{
  color: black !important;
}
.nav-link5{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #66c1bf;
}
.nav-link5:hover{
  color: black !important;
}

.excell{
    font-size: 100px;
    text-align: left !important;
}
.textExcell{
    font-size: 15px;
    text-align: left !important;
    padding-top: 60px;
}
.pagination{
   justify-content: center;
}
.rapports{
  font-size: 15px;
  text-align: center !important;
}
.form-inline{
  display: block;
}

</style>
